import { render, staticRenderFns } from "./CurrentBaseFilter.vue?vue&type=template&id=28315240&scoped=true&"
import script from "./CurrentBaseFilter.vue?vue&type=script&lang=js&"
export * from "./CurrentBaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./CurrentBaseFilter.vue?vue&type=style&index=0&id=28315240&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28315240",
  null
  
)

export default component.exports